
import RcDomainObject from "@/domain/common/RcDomainObject.js";
import Option from "@/domain/model/schedule/question/option/Option.js";
import Catalog from "@/domain/session/Catalog.js";
import CheckListItemOption from "../../checklist/item/option/CheckListItemOption";
import CheckListItem from "../../checklist/item/CheckListItem";


export default class Repair extends RcDomainObject {
  
  static MODEL_NAME = "VehicleInspectionRepair";
  
  static Fields = {
    REMARKS: 'remarks',
    OPTION: 'VehicleScheduleQuestionOption',
    ITEM_OPTION: 'CheckListItemOption',
    ITEM: 'CheckListItem',
  }
  
  debug() {
    let log = this.domain.logger();
    let option = this.option().find();
    let checklistItem = this.checklistItem().find();
    let checklistItemOption = this.checklistItemOption().find();
    
    log.info("   Repair Id: {0}", this.id());
    log.info("      Option Id: {0}({1})", [option.name(), option.id()]);
    log.info("      Checklist Item Id: {0}({1})", [checklistItem.name(), checklistItem.id()]);
    log.info("      Checklist Item Option Id: {0}({1})", [checklistItemOption.name(), checklistItemOption.id()]);
    log.info("      Remarks: {0}", this.remarks());
  }
  constructor(domain, data) {
    super(domain, data, Repair.MODEL_NAME);
    this.C = new Catalog();
  }

  find() {
    if (this.isNew()) {
      return this;
    }
    return this.domain.repairs().findById(this.id());
  }
  
  option() {
    var obj = this.get(Repair.Fields.OPTION);
    return new Option(this.domain, obj);
  }
  
  checklistItemOption() {
    var obj = this.get(Repair.Fields.ITEM_OPTION);
    return new CheckListItemOption(this.domain, obj);
  }

  withChecklistItemOption(itemOption) {
    this.put(Repair.Fields.ITEM_OPTION, itemOption.data);
    return this;
  }

  checklistItem() {
    var obj = this.get(Repair.Fields.ITEM);
    return new CheckListItem(this.domain, obj);
  }

  withChecklistItem(checklistItem) {
    this.put(Repair.Fields.ITEM, checklistItem.data);
    return this;
  }

  withOption(option) {
    this.put(Repair.Fields.OPTION, option.data);
    return this;
  }
  
  remarks() {
    return this.getString(Repair.Fields.REMARKS);
  }
  
  withRemarks(remarks) {
    this.put(Repair.Fields.REMARKS, remarks);
    return this;
  }
}